export const Languages = {
    FRENCH: 1,
    GERMAN: 2,
    ENGLISH: 3,
    ITALIAN: 4
};
